const device = () => import('@/pages/statistics/device/index.vue');

export default [{
    path: '/statistics/device',
    component: device,
    meta: [{
        name: '统计分析'
    },
    {
        name: '设备分析',
        activeRoute: '/statistics/device'
    }]
}];